<div class="ui-product-change">
  <div class="ui-product-change-content" mat-dialog-content>
    <div class="ui-product-change-details">
      <object type="image/svg+xml" data="assets/images/icons/products-change.svg"></object>
      <h3 class="ui-title">Modificar mi producto</h3>
      <p *ngIf="!contractsSelected">Seleccioná el producto a cambiar y el nuevo producto a contratar, un asistente revisará tu solicitud y se contactará con vos.</p>
      <p *ngIf="contractsSelected">Seleccioná el nuevo producto a contratar, un asistente revisará tu solicitud y se contactará con vos.</p>
    </div>

    <form class="ui-dialog" [formGroup]="formData">
      <div class="ui-form">
        <div class="ui-form-row" *ngIf="!contractsSelected">
          <mat-form-field class="ui-input">
            <mat-label>Producto</mat-label>
            <mat-select formControlName="contract" (selectionChange)="onContractChange(this.formData.get('contract')?.value)">
              <mat-option *ngFor="let item of contractsData" [value]="item">{{item.product.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('contract', 'validate')">{{formHasError('contract', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Nuevo producto</mat-label>
            <mat-select formControlName="product">
              <mat-option *ngFor="let item of productsData" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('product', 'validate')">{{formHasError('product', 'message')}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-product-change-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
    <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Solicitar cambio</button>
  </div>
</div>